import moment from "moment";
import React from "react";
import { Async } from "react-select";
import DatePicker from "Utils/DatePicker";
import useAsyncSearch from "../../../hooks/useAsyncSearch";

const listado_usuarios = [];
const FiltrosPendientes = ({
    fecha_pendiente_inicial,
    fecha_pendiente_final,
    usuario_pendiente,
    setFecha,
    setUsuarioValue,
}) => {
    const { getOptions: getUsuarios } = useAsyncSearch(
        "usuarios",
        listado_usuarios
    );

    return (
        <div className="row py-2 px-4 justify-content-between">
            <div className="row col-8 col-sm-12 col-md-10">
                <div className="col-12 col-lg-3 col-md-3 form-group pl-0">
                    <label htmlFor="">Fecha inicial</label>
                    <DatePicker
                        value={fecha_pendiente_inicial}
                        maxDate={
                            new Date(
                                moment(
                                    moment().format("YYYY-MM-DD"),
                                    "YYYY-MM-DD"
                                )
                            )
                        }
                        onChange={(date) => {
                            setFecha(
                                "Inicial",
                                date,
                                true,
                                "fecha_pendiente_inicial"
                            );
                        }}
                    />
                </div>
                <div className="col-12 col-lg-3 col-md-3 form-group pl-0">
                    <label htmlFor="">Fecha final</label>
                    <DatePicker
                        value={fecha_pendiente_final}
                        minDate={
                            new Date(
                                moment(fecha_pendiente_inicial, "YYYY-MM-DD")
                            )
                        }
                        onChange={(date) => {
                            setFecha(
                                "Final",
                                date,
                                true,
                                "fecha_pendiente_final"
                            );
                        }}
                    />
                </div>
                <div className="col-12 col-lg-3 col-md-3 form-group pl-0">
                    <label>Enviado por</label>
                    <Async
                        className="form-control"
                        labelKey="first_name"
                        valueKey="id"
                        searchPromptText="Escriba para buscar"
                        loadOptions={getUsuarios}
                        placeholder={"Usuario"}
                        onChange={(e) => {
                            setUsuarioValue(e, true);
                        }}
                        value={usuario_pendiente}
                    />
                </div>
            </div>
        </div>
    );
};

export default FiltrosPendientes;
